import { render, staticRenderFns } from "./TeSideBar.vue?vue&type=template&id=4003ed27"
import script from "./TeSideBar.vue?vue&type=script&lang=js"
export * from "./TeSideBar.vue?vue&type=script&lang=js"
import style0 from "./TeSideBar.vue?vue&type=style&index=0&id=4003ed27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports